import { render, staticRenderFns } from "./SeasonHarvestTable.vue?vue&type=template&id=3ac20f28&scoped=true&"
import script from "./SeasonHarvestTable.vue?vue&type=script&lang=js&"
export * from "./SeasonHarvestTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac20f28",
  null
  
)

export default component.exports